(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(bar) {
      var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
      var messages = Array.prototype.slice.call(bar.querySelectorAll('[data-announcement-message]'));
      var current = 0;
      var paused = false;
      var timer = null;

      function nowSeconds() {
        return Math.floor(Date.now() / 1000);
      }

      /* Cached HTML can outlive a message's end time — drop those here. */
      function isLive(el) {
        var endsAt = parseInt(el.getAttribute('data-ends-at'), 10);
        return !endsAt || nowSeconds() < endsAt;
      }

      function show(next) {
        messages.forEach(function (el, i) {
          var active = i === next;
          el.classList.toggle('is-active', active);
          if (active) {
            el.removeAttribute('aria-hidden');
            el.inert = false;
          } else {
            el.setAttribute('aria-hidden', 'true');
            el.inert = true;
          }
        });
        current = next;
      }

      function prune() {
        var live = messages.filter(isLive);
        if (live.length === messages.length) return;
        messages.filter(function (el) { return !isLive(el); }).forEach(function (el) { el.remove(); });
        messages = live;
        if (!messages.length) {
          bar.remove();
          stop();
          return;
        }
        show(0);
      }

      function advance() {
        prune();
        if (paused || messages.length < 2) return;
        show((current + 1) % messages.length);
      }

      function start() {
        if (!timer) timer = setInterval(advance, interval);
      }

      function stop() {
        clearInterval(timer);
        timer = null;
      }

      prune();
      if (messages.length < 2) return;

      bar.addEventListener('mouseenter', function () { paused = true; });
      bar.addEventListener('mouseleave', function () { paused = false; });
      bar.addEventListener('focusin', function () { paused = true; });
      bar.addEventListener('focusout', function () { paused = false; });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      start();
    }

    function init(root) {
      (root || document).querySelectorAll('[data-announcement-rotator]').forEach(setup);
    }

    init();
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.cart-drawer__panel');
      this.inner = this.querySelector('[data-cart-inner]');
      this.sectionId = this.dataset.sectionId;
      this.lastFocus = null;

      this.onToggleClick = (event) => {
        const trigger = event.target.closest('[data-cart-toggle]');
        if (!trigger) return;
        event.preventDefault();
        this.open();
      };
      document.addEventListener('click', this.onToggleClick);

      this.onSubmit = (event) => this.onProductSubmit(event);
      document.addEventListener('submit', this.onSubmit);

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-close]')) {
          event.preventDefault();
          this.close();
          return;
        }
        const remove = event.target.closest('[data-cart-remove]');
        if (remove) {
          event.preventDefault();
          const line = remove.closest('[data-cart-line]');
          if (line) this.changeQuantity(line.dataset.key, 0);
          return;
        }
        const step = event.target.closest('[data-qty-down], [data-qty-up]');
        if (step) {
          const line = step.closest('[data-cart-line]');
          const input = line && line.querySelector('[data-qty-input]');
          if (!input) return;
          const current = parseInt(input.value, 10) || 0;
          const isUp = step.hasAttribute('data-qty-up');
          this.changeQuantity(line.dataset.key, Math.max(0, current + (isUp ? 1 : -1)));
        }
      });

      this.addEventListener('change', (event) => {
        const input = event.target.closest('[data-qty-input]');
        if (!input) return;
        const line = input.closest('[data-cart-line]');
        if (line) this.changeQuantity(line.dataset.key, Math.max(0, parseInt(input.value, 10) || 0));
      });

      this.addEventListener('keydown', (event) => {
        if (!this.classList.contains('is-open')) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
        } else if (event.key === 'Tab') {
          this.trapFocus(event);
        }
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onToggleClick);
      document.removeEventListener('submit', this.onSubmit);
    }

    get root() {
      return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    }

    open() {
      if (this.classList.contains('is-open')) return;
      this.lastFocus = document.activeElement;
      this.classList.add('is-open');
      this.panel.removeAttribute('inert');
      this.panel.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cart-drawer-open');
      window.requestAnimationFrame(() => {
        const target = this.panel.querySelector('[data-cart-close]') || this.panel;
        target.focus();
      });
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.panel.setAttribute('inert', '');
      this.panel.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cart-drawer-open');
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') this.lastFocus.focus();
    }

    focusables() {
      return Array.from(
        this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter((el) => el.offsetWidth > 0 || el.offsetHeight > 0);
    }

    trapFocus(event) {
      const items = this.focusables();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    async changeQuantity(key, quantity) {
      this.setBusy(true);
      try {
        const response = await fetch(`${this.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity,
            sections: this.sectionId,
            sections_url: window.location.pathname,
          }),
        });
        const data = await response.json();
        this.renderFromSections(data.sections);
        this.syncCount(data.item_count);
        if (this.classList.contains('is-open')) this.panel.focus();
      } catch (error) {
        this.showError();
      } finally {
        this.setBusy(false);
      }
    }

    async onProductSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;
      if (!form.querySelector('[name="id"]')) return;

      event.preventDefault();
      const submitter = event.submitter;
      if (submitter) submitter.setAttribute('aria-busy', 'true');

      const formData = new FormData(form);
      formData.append('sections', this.sectionId);
      formData.append('sections_url', window.location.pathname);

      try {
        const response = await fetch(`${this.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });
        const data = await response.json();
        if (!response.ok) {
          this.open();
          this.showError(data.description || data.message);
          return;
        }
        if (data.sections) {
          this.renderFromSections(data.sections);
        } else {
          await this.refresh();
        }
        this.syncCount();
        this.open();
      } catch (error) {
        form.submit();
      } finally {
        if (submitter) submitter.removeAttribute('aria-busy');
      }
    }

    async refresh() {
      const response = await fetch(`${this.root}?section_id=${this.sectionId}`);
      this.swap(await response.text());
    }

    renderFromSections(sections) {
      if (sections && sections[this.sectionId]) this.swap(sections[this.sectionId]);
    }

    swap(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('[data-cart-inner]');
      if (next && this.inner) {
        this.inner.innerHTML = next.innerHTML;
        this.reinitApps();
      }
    }

    // After an innerHTML swap, inline <script>s brought in by app blocks (e.g. AfterShip
    // shipping protection) don't execute, and app JS that injected a widget doesn't know
    // the drawer was re-rendered. Re-run those scripts and fire the cart events such apps
    // commonly listen to, so the protection widget re-hydrates into the fresh markup.
    reinitApps() {
      if (!this.inner) return;
      this.inner.querySelectorAll('script').forEach((old) => {
        const copy = document.createElement('script');
        for (const attr of old.attributes) copy.setAttribute(attr.name, attr.value);
        copy.textContent = old.textContent;
        old.replaceWith(copy);
      });
      ['cart:refresh', 'cart:change', 'cart:updated'].forEach((name) => {
        document.dispatchEvent(new CustomEvent(name, { detail: { source: 'cart-drawer' } }));
      });
    }

    syncCount(count) {
      let value = count;
      if (typeof value !== 'number') {
        const el = this.querySelector('[data-cart-count]');
        value = el ? parseInt(el.textContent, 10) || 0 : 0;
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: value } }));
    }

    setBusy(state) {
      if (this.inner) this.inner.setAttribute('aria-busy', state ? 'true' : 'false');
    }

    showError(message) {
      const el = this.querySelector('[data-cart-error]');
      if (!el) return;
      el.textContent = message || this.dataset.errorGeneric || '';
      el.hidden = false;
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartPage extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.inner = this.querySelector('[data-cart-inner]');
      this.hideUpdate();

      this.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-cart-remove]');
        if (remove) {
          event.preventDefault();
          const line = remove.closest('[data-cart-line]');
          if (line) this.change(line.dataset.key, 0);
          return;
        }
        const step = event.target.closest('[data-qty-down], [data-qty-up]');
        if (step) {
          const line = step.closest('[data-cart-line]');
          const input = line && line.querySelector('[data-qty-input]');
          if (!input) return;
          const current = parseInt(input.value, 10) || 0;
          const isUp = step.hasAttribute('data-qty-up');
          this.change(line.dataset.key, Math.max(0, current + (isUp ? 1 : -1)));
        }
      });

      this.addEventListener('change', (event) => {
        const input = event.target.closest('[data-qty-input]');
        if (!input) return;
        const line = input.closest('[data-cart-line]');
        if (line) this.change(line.dataset.key, Math.max(0, parseInt(input.value, 10) || 0));
      });
    }

    get root() {
      return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    }

    hideUpdate() {
      const update = this.querySelector('[data-cart-update]');
      if (update) update.hidden = true;
    }

    async change(key, quantity) {
      this.setBusy(true);
      try {
        const response = await fetch(`${this.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity,
            sections: this.sectionId,
            sections_url: window.location.pathname,
          }),
        });
        const data = await response.json();
        if (data.sections && data.sections[this.sectionId]) {
          const doc = new DOMParser().parseFromString(data.sections[this.sectionId], 'text/html');
          const next = doc.querySelector('[data-cart-inner]');
          if (next && this.inner) {
            this.inner.innerHTML = next.innerHTML;
            this.reinitApps();
          }
          this.hideUpdate();
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: data.item_count } }));
      } catch (error) {
        this.showError();
      } finally {
        this.setBusy(false);
      }
    }

    setBusy(state) {
      if (this.inner) this.inner.setAttribute('aria-busy', state ? 'true' : 'false');
    }

    // After an innerHTML swap, re-run inline app-block scripts (e.g. AfterShip shipping
    // protection) and fire the cart events such apps listen to, so their widget
    // re-hydrates into the freshly re-rendered summary. Mirrors cart-drawer.liquid.
    reinitApps() {
      if (!this.inner) return;
      this.inner.querySelectorAll('script').forEach((old) => {
        const copy = document.createElement('script');
        for (const attr of old.attributes) copy.setAttribute(attr.name, attr.value);
        copy.textContent = old.textContent;
        old.replaceWith(copy);
      });
      ['cart:refresh', 'cart:change'].forEach((name) => {
        document.dispatchEvent(new CustomEvent(name, { detail: { source: 'cart-page' } }));
      });
    }

    showError() {
      const el = this.querySelector('[data-cart-error]');
      if (!el) return;
      el.textContent = this.dataset.errorGeneric || '';
      el.hidden = false;
    }
  }

  if (!customElements.get('cart-page')) {
    customElements.define('cart-page', CartPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionGrid extends HTMLElement {
    connectedCallback() {
      this.baseUrl = this.dataset.url;
      this.sectionId = this.dataset.sectionId;

      this.addEventListener('change', (event) => {
        const control = event.target;
        if (control.matches('[data-sort]') || control.closest('[data-filter-form]')) {
          this.applyFilters();
        }
      });

      this.addEventListener('submit', (event) => {
        if (event.target.closest('[data-filter-form]')) {
          event.preventDefault();
          this.applyFilters();
        }
      });

      this.addEventListener('click', (event) => {
        const more = event.target.closest('[data-load-more]');
        if (more) {
          event.preventDefault();
          this.loadMore(more.getAttribute('href'));
        }
      });

      window.addEventListener('popstate', () => this.renderFrom(location.href, false));
    }

    get form() {
      return this.querySelector('[data-filter-form]');
    }

    buildUrl() {
      const params = new URLSearchParams();
      const form = this.form;
      if (form) {
        new FormData(form).forEach((value, key) => {
          if (String(value).trim() !== '') params.append(key, value);
        });
      }
      const sort = this.querySelector('[data-sort]');
      if (sort && sort.value && !params.has('sort_by')) params.append('sort_by', sort.value);
      const query = params.toString();
      return query ? `${this.baseUrl}?${query}` : this.baseUrl;
    }

    applyFilters() {
      const url = this.buildUrl();
      this.renderFrom(url, false).then((ok) => {
        if (ok) window.history.pushState({}, '', url);
      });
    }

    loadMore(url) {
      this.renderFrom(url, true, false);
    }

    async renderFrom(url, append, scroll = true) {
      this.classList.add('collection--loading');
      const fetchUrl = `${url}${url.includes('?') ? '&' : '?'}section_id=${this.sectionId}`;
      try {
        const response = await fetch(fetchUrl);
        if (!response.ok) throw new Error(response.statusText);
        const markup = await response.text();
        const doc = new DOMParser().parseFromString(markup, 'text/html');

        const newGrid = doc.querySelector('[data-grid]');
        const newFooter = doc.querySelector('[data-footer]');
        const currentGrid = this.querySelector('[data-grid]');

        if (append) {
          if (newGrid && currentGrid) currentGrid.append(...newGrid.children);
          this.replaceNode('[data-footer]', newFooter);
        } else {
          this.replaceNode('[data-controls]', doc.querySelector('[data-controls]'));
          this.replaceBody(doc);
          if (scroll) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        this.classList.remove('collection--loading');
        return true;
      } catch (error) {
        window.location.href = url;
        return false;
      }
    }

    replaceNode(selector, incoming) {
      const existing = this.querySelector(selector);
      if (existing && incoming) {
        existing.replaceWith(incoming);
      } else if (existing && !incoming) {
        existing.remove();
      }
    }

    replaceBody(doc) {
      const newGrid = doc.querySelector('[data-grid]');
      const newFooter = doc.querySelector('[data-footer]');
      const newEmpty = doc.querySelector('.collection__empty');
      const anchor = this.querySelector('.collection__body');
      if (!anchor) return;

      const currentGrid = this.querySelector('[data-grid]');
      const currentFooter = this.querySelector('[data-footer]');
      const currentEmpty = anchor.querySelector('.collection__empty');

      if (currentGrid) currentGrid.remove();
      if (currentFooter) currentFooter.remove();
      if (currentEmpty) currentEmpty.remove();

      if (newGrid) anchor.append(newGrid);
      if (newFooter) anchor.append(newFooter);
      if (newEmpty) anchor.append(newEmpty);
    }
  }

  if (!customElements.get('collection-grid')) {
    customElements.define('collection-grid', CollectionGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["design-brief"] && !Shopify.designMode) return;
  try {
    
  class DesignBriefForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-form]');
      if (!this.form) return;

      const configEl = this.querySelector('[data-design-brief-config]');
      const config = configEl ? JSON.parse(configEl.textContent) : {};
      this.products = (config.products || [])
        .map((product) => ({
          name: (product.name || '').trim(),
          colors: (product.colors || []).map((color) => color.trim()).filter(Boolean),
          note: (product.note || '').trim(),
        }))
        .filter((product) => product.name);
      this.darkColors = (config.darkColors || []).map((v) => v.trim().toLowerCase()).filter(Boolean);

      this.intakeUrl = this.dataset.intakeUrl || '';
      this.fileUrl = this.dataset.fileUrl || '';
      this.minPerDesign = parseInt(this.dataset.minPerDesign, 10) || 50;
      this.maxFiles = parseInt(this.dataset.maxFiles, 10) || 10;
      this.maxBytes = (parseInt(this.dataset.maxFileMb, 10) || 25) * 1024 * 1024;
      this.minSeconds = parseInt(this.dataset.minSeconds, 10) || 8;
      this.storageKey = this.dataset.storageKey || 'design-brief';
      this.turnstileKey = this.dataset.turnstileKey || '';

      this.panels = Array.from(this.querySelectorAll('[data-step]'));
      this.pips = Array.from(this.querySelectorAll('[data-step-pip]'));
      this.rowsWrap = this.querySelector('[data-rows]');
      this.rowTemplate = this.querySelector('[data-row-template]');
      this.files = [];
      this.step = 1;
      this.startedAt = Date.now();
      this.submitting = false;

      this.buildRow();
      this.restore();
      this.bind();
      this.applyLogic();
      this.updateChecks();
      this.showStep(1);
      this.mountTurnstile();
    }

    /* ---------------- wiring ---------------- */

    bind() {
      this.querySelector('[data-next]').addEventListener('click', () => this.next());
      this.querySelector('[data-back]').addEventListener('click', () => this.back());
      this.querySelector('[data-add-row]').addEventListener('click', () => {
        const row = this.buildRow();
        const select = row.querySelector('[data-product-select]');
        if (select) select.focus();
        this.updateChecks();
        this.save();
      });

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.submit();
      });

      this.form.addEventListener('change', (event) => {
        this.applyLogic();
        this.updateChecks();
        if (event.target.matches('[data-error-shown]')) this.clearError(event.target);
        this.save();
      });

      this.form.addEventListener('input', () => {
        this.updateChecks();
        this.debounceSave();
      });

      this.bindDropZone();
      this.bindPhoneMask();
      this.bindLightbox();
    }

    // Formats as the partner types. A number that looks domestic gets (920) 555-0142;
    // anything starting with + is left as entered beyond stripping punctuation, because
    // international formats vary far too much to guess at. Only reformats when the caret
    // is at the end, so editing mid-number doesn't yank the cursor around. n8n still
    // normalises to E.164 before ClickUp sees it — this is courtesy, not validation.
    bindPhoneMask() {
      const input = this.form.elements.contact_phone;
      if (!input) return;
      input.addEventListener('input', () => {
        const raw = input.value;
        if (input.selectionStart !== raw.length) return;
        const digits = raw.replace(/\D/g, '');
        if (raw.trim().startsWith('+') || digits.length > 10) {
          input.value = `+${digits}`;
          return;
        }
        const area = digits.slice(0, 3);
        const mid = digits.slice(3, 6);
        const last = digits.slice(6, 10);
        if (digits.length > 6) input.value = `(${area}) ${mid}-${last}`;
        else if (digits.length > 3) input.value = `(${area}) ${mid}`;
        else if (digits.length) input.value = `(${area}`;
        else input.value = '';
      });
    }

    // A <dialog> carries the focus trap, Escape handling and inert background for
    // free, which is most of what a lightbox has to get right.
    bindLightbox() {
      const dialog = this.querySelector('[data-lightbox]');
      if (!dialog) return;
      const image = dialog.querySelector('[data-lightbox-img]');

      this.querySelectorAll('[data-zoom]').forEach((button) => {
        button.addEventListener('click', () => {
          // Shape the box before it opens, so it doesn't snap when the image lands.
          if (button.dataset.width) image.width = button.dataset.width;
          if (button.dataset.height) image.height = button.dataset.height;
          image.src = button.dataset.large;
          image.alt = button.dataset.title || '';
          dialog.showModal();
        });
      });

      // Drop the src on the way out so a full-size image isn't held behind the form.
      // Done on the paths we control rather than via the dialog's `close` event alone:
      // that event doesn't fire in every browser (it doesn't in the one this was tested
      // in), and a cleanup that silently never runs is worse than no cleanup at all.
      const close = () => {
        dialog.close();
        image.removeAttribute('src');
      };

      dialog.querySelector('[data-lightbox-close]').addEventListener('click', close);
      // Clicking the backdrop lands on the dialog itself, never on its children.
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });
      // Escape closes natively, so this is the only hook for that path.
      dialog.addEventListener('close', () => image.removeAttribute('src'));
    }

    debounceSave() {
      clearTimeout(this.saveTimer);
      this.saveTimer = setTimeout(() => this.save(), 400);
    }

    /* ---------------- product rows ---------------- */

    buildRow(state) {
      const fragment = this.rowTemplate.content.cloneNode(true);
      const row = fragment.querySelector('[data-row]');
      const index = this.rowsWrap.children.length;
      const select = row.querySelector('[data-product-select]');
      const label = row.querySelector('[data-product-label]');
      const qty = row.querySelector('[data-row-qty]');
      const qtyLabel = row.querySelector('[data-qty-label]');
      const rowId = `${this.storageKey}-row-${index}`;

      select.id = `${rowId}-product`;
      label.setAttribute('for', select.id);
      qty.id = `${rowId}-qty`;
      qtyLabel.setAttribute('for', qty.id);

      select.innerHTML = '';
      const placeholder = new Option('Choose a product', '');
      placeholder.disabled = true;
      placeholder.selected = true;
      select.add(placeholder);
      this.products.forEach((product) => select.add(new Option(product.name, product.name)));

      select.addEventListener('change', () => {
        this.renderSwatches(row);
        this.save();
      });

      const remove = row.querySelector('[data-remove-row]');
      remove.addEventListener('click', () => {
        row.remove();
        this.reindexRows();
        this.updateChecks();
        this.save();
      });

      this.rowsWrap.append(row);
      this.reindexRows();
      if (state) this.fillRow(row, state);
      this.renderSwatches(row, state);
      return row;
    }

    // Colors belong to the product, not to the brand: the hoodie blank and the hat
    // blank come in different ranges, so the chips are rebuilt whenever the product
    // changes. A shared list would offer partners colors we can't actually make.
    renderSwatches(row, state) {
      const select = row.querySelector('[data-product-select]');
      const swatches = row.querySelector('[data-swatches]');
      const note = row.querySelector('[data-row-note]');
      const product = this.products.find((entry) => entry.name === select.value);
      const chosen = state ? state.colors || [] : this.selectedColors(row);

      swatches.innerHTML = '';
      note.textContent = product ? product.note : '';
      note.hidden = !(product && product.note);
      if (!product) return;

      const partnerBlank = this.form.elements.blank_source.value === 'Partner-sourced blank';
      product.colors.concat(partnerBlank ? ['Other'] : []).forEach((color, colorIndex) => {
        const wrap = document.createElement('div');
        wrap.className = 'design-brief__swatch';
        if (color === 'Other') wrap.setAttribute('data-other-swatch', '');

        const id = `${select.id}-color-${colorIndex}`;
        const chip = document.createElement('label');
        chip.className = 'design-brief__swatch-label';
        chip.setAttribute('for', id);
        chip.innerHTML =
          `<input type="checkbox" id="${id}">` +
          `<span class="design-brief__swatch-dot"></span>` +
          '<span class="design-brief__swatch-name"></span>';

        const box = chip.querySelector('input');
        box.setAttribute('data-color', color);
        box.checked = chosen.includes(color);
        chip.querySelector('.design-brief__swatch-dot').style.background = this.swatchColor(color);
        chip.querySelector('.design-brief__swatch-name').textContent = color;

        wrap.append(chip);
        swatches.append(wrap);
      });

      this.syncOther(row);
    }

    selectedColors(row) {
      return Array.from(row.querySelectorAll('[data-color]'))
        .filter((box) => box.checked)
        .map((box) => box.dataset.color);
    }

    syncOther(row) {
      const select = row.querySelector('[data-product-select]');
      const otherBox = row.querySelector('[data-color="Other"]');
      const otherWrap = row.querySelector('[data-other-wrap]');
      const otherInput = row.querySelector('[data-other-input]');
      const otherLabel = row.querySelector('[data-other-label]');
      if (otherInput && otherLabel) {
        otherInput.id = `${select.id}-other`;
        otherLabel.setAttribute('for', otherInput.id);
      }
      otherWrap.hidden = !(otherBox && otherBox.checked);
    }

    fillRow(row, state) {
      if (state.product) row.querySelector('[data-product-select]').value = state.product;
      const qty = row.querySelector('[data-row-qty]');
      if (state.units) qty.value = state.units;
      const otherInput = row.querySelector('[data-other-input]');
      if (otherInput && state.otherColor) otherInput.value = state.otherColor;
    }

    reindexRows() {
      Array.from(this.rowsWrap.children).forEach((row, index) => {
        const remove = row.querySelector('[data-remove-row]');
        if (remove) remove.hidden = index === 0;
      });
    }

    swatchColor(name) {
      const map = {
        black: '#0a0a0a',
        navy: '#1b2a4a',
        natural: '#e8e0d0',
        grey: '#8b8b8b',
        gray: '#8b8b8b',
        sandstone: '#c9b79c',
        'citadel': '#6b7f96',
        brown: '#5a4632',
        red: '#a02020',
        white: '#ffffff',
      };
      const key = name.toLowerCase().trim();
      if (map[key]) return map[key];
      // Two-tone hats read "Crown/Accent" — show the chip split down the middle.
      if (key.includes('/')) {
        const halves = key.split('/').map((part) => map[part.trim()] || '#cccccc');
        return `linear-gradient(90deg, ${halves[0]} 0 50%, ${halves[1]} 50% 100%)`;
      }
      return '#cccccc';
    }

    readRows() {
      return Array.from(this.rowsWrap.children).map((row) => {
        const otherInput = row.querySelector('[data-other-input]');
        const qty = row.querySelector('[data-row-qty]');
        return {
          product: row.querySelector('[data-product-select]').value,
          colors: this.selectedColors(row),
          otherColor: otherInput ? otherInput.value.trim() : '',
          units: parseInt(qty && qty.value, 10) || 0,
        };
      });
    }

    // Dark vs light falls out of the colors chosen, so the partner is never asked.
    // A two-tone hat is judged on the crown — the half the artwork sits on.
    garmentValue(rows) {
      let dark = false;
      let light = false;
      rows.forEach((row) => {
        row.colors.forEach((color) => {
          if (color === 'Other') return;
          if (this.darkColors.includes(color.split('/')[0].trim().toLowerCase())) dark = true;
          else light = true;
        });
      });
      if (dark && light) return 'Both';
      if (dark) return 'Dark';
      if (light) return 'Light';
      return '';
    }

    productLines(rows) {
      return rows
        .filter((row) => row.product && row.units > 0)
        .map((row) => {
          const colors = row.colors.map((color) =>
            color === 'Other' && row.otherColor ? `Other (${row.otherColor})` : color
          );
          return `${row.product} — ${row.units} units${colors.length ? ` — open to ${colors.join(', ')}` : ''}`;
        })
        .join(' / ');
    }

    designCount() {
      const parsed = parseInt(this.form.elements.design_count.value, 10);
      return Number.isNaN(parsed) ? 1 : parsed;
    }

    updateChecks() {
      const rows = this.readRows();
      Array.from(this.rowsWrap.children).forEach((row) => this.syncOther(row));
      this.checkMinimum(rows);
      this.checkDeadline(rows.reduce((sum, row) => sum + row.units, 0));
    }

    checkMinimum(rows) {
      const warning = this.querySelector('[data-min-warning]');
      const count = this.designCount();
      const short = rows.some((row) => row.units > 0 && row.units / count < this.minPerDesign);
      if (count > 1 && short) {
        warning.textContent = `Heads up — if you're splitting these designs across products, each one needs ${this.minPerDesign} per product. Tell us how you're splitting it in the brief and we'll work it out with you.`;
        warning.hidden = false;
      } else {
        warning.hidden = true;
      }
    }

    checkDeadline(total) {
      const warning = this.querySelector('[data-deadline-warning]');
      const input = this.form.elements.needed_by;
      if (!input.value) {
        warning.hidden = true;
        return;
      }
      const days = Math.ceil((new Date(input.value) - new Date()) / 86400000);
      const needed = total >= 800 ? 42 : 28;
      if (days < needed) {
        warning.textContent = `That's tight. A run this size usually needs about ${Math.round(needed / 7)} weeks from brief to in-hand — two of those are concepts. Send it anyway and we'll tell you straight away what's achievable.`;
        warning.hidden = false;
      } else {
        warning.hidden = true;
      }
    }

    /* ---------------- conditional logic ---------------- */

    applyLogic() {
      const locked = this.form.elements.co_branding.value === 'Co-branded';
      const lockedCard = this.querySelector('[data-blank-locked]');
      const blankChoices = this.querySelector('[data-blank-choices]');

      lockedCard.hidden = !locked;
      blankChoices.hidden = locked;
      if (locked) this.form.elements.blank_source.value = 'Bold Aviator blank';

      // Blank source decides whether "Other" is offered, so the chips are rebuilt
      // when it changes. Color is a property of the garment, not of the branding.
      Array.from(this.rowsWrap.children).forEach((row) => this.renderSwatches(row));

      this.querySelector('[data-minimum-copy]').hidden = !(this.designCount() > 1);
      this.querySelector('[data-size-grid]').hidden = this.form.elements.has_sizes.value !== 'yes';
      this.querySelector('[data-deadline-detail]').hidden = this.form.elements.deadline_type.value !== 'Hard';
    }

    /* ---------------- steps ---------------- */

    showStep(step) {
      this.step = step;
      this.panels.forEach((panel) => panel.classList.toggle('is-active', Number(panel.dataset.step) === step));
      this.pips.forEach((pip) => {
        const num = Number(pip.dataset.stepPip);
        pip.classList.toggle('is-current', num === step);
        pip.classList.toggle('is-done', num < step);
      });
      this.querySelector('[data-bar]').style.width = `${(step / this.panels.length) * 100}%`;
      this.querySelector('[data-progress-text]').textContent = `Step ${step} of ${this.panels.length}`;
      this.querySelector('[data-back]').hidden = step === 1;
      this.querySelector('[data-next]').hidden = step === this.panels.length;
      this.querySelector('[data-submit]').hidden = step !== this.panels.length;

      // The panel is visible now, so the widget can measure itself.
      this.renderTurnstile();
    }

    next() {
      if (!this.validateStep(this.step)) return;
      if (this.step < this.panels.length) {
        this.showStep(this.step + 1);
        this.focusPanel();
      }
    }

    back() {
      if (this.step > 1) {
        this.showStep(this.step - 1);
        this.focusPanel();
      }
    }

    focusPanel() {
      const panel = this.panels[this.step - 1];
      const field = panel.querySelector('input, select, textarea, button');
      if (field) field.focus({ preventScroll: true });
      this.querySelector('[data-progress]').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* ---------------- validation ---------------- */

    validateStep(step) {
      const panel = this.panels[step - 1];
      let valid = true;
      let firstBad = null;

      panel.querySelectorAll('[required]').forEach((field) => {
        const ok = field.type === 'radio' ? this.form.elements[field.name].value !== '' : field.checkValidity();
        if (ok) {
          this.clearError(field);
          return;
        }
        valid = false;
        firstBad = firstBad || field;
        this.setError(field, this.messageFor(field));
      });

      if (step === 3) {
        const rows = this.readRows();
        const usable = rows.some((row) => row.product && row.units > 0);
        const error = this.querySelector('[data-rows-error]');
        if (!usable) {
          valid = false;
          error.textContent = 'Pick a product, tap a color, and give us a number — even a rough one.';
          error.hidden = false;
          firstBad = firstBad || this.rowsWrap.querySelector('[data-product-select]');
        } else {
          error.hidden = true;
        }
      }

      if (step === 4) {
        const error = this.querySelector('[data-files-error]');
        if (this.files.length === 0) {
          valid = false;
          error.textContent = 'We need at least your logo. Drop it in above.';
          error.hidden = false;
          firstBad = firstBad || this.querySelector('[data-drop]');
        } else {
          error.hidden = true;
        }
      }

      if (firstBad) firstBad.focus({ preventScroll: false });
      return valid;
    }

    messageFor(field) {
      if (field.type === 'radio') return 'Pick one to carry on.';
      if (field.type === 'email') return 'We need an email address we can reply to.';
      if (field.type === 'date') return 'Give us a date, even an approximate one.';
      if (field.tagName === 'SELECT') return 'Choose one to carry on.';
      return 'This one we need.';
    }

    setError(field, message) {
      const wrap = field.closest('.design-brief__field');
      if (!wrap) return;
      const error = wrap.querySelector('[data-error]');
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('data-error-shown', '');
    }

    clearError(field) {
      const wrap = field.closest('.design-brief__field');
      if (!wrap) return;
      const error = wrap.querySelector('[data-error]');
      if (error) error.hidden = true;
      field.removeAttribute('aria-invalid');
      field.removeAttribute('data-error-shown');
    }

    /* ---------------- files ---------------- */

    bindDropZone() {
      const drop = this.querySelector('[data-drop]');
      const input = this.querySelector('[data-file-input]');

      drop.addEventListener('click', () => input.click());
      drop.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          input.click();
        }
      });
      input.addEventListener('change', () => {
        this.addFiles(Array.from(input.files));
        input.value = '';
      });

      ['dragenter', 'dragover'].forEach((name) =>
        drop.addEventListener(name, (event) => {
          event.preventDefault();
          drop.classList.add('is-dragging');
        })
      );
      ['dragleave', 'drop'].forEach((name) =>
        drop.addEventListener(name, (event) => {
          event.preventDefault();
          drop.classList.remove('is-dragging');
        })
      );
      drop.addEventListener('drop', (event) => {
        if (event.dataTransfer && event.dataTransfer.files) this.addFiles(Array.from(event.dataTransfer.files));
      });
    }

    addFiles(incoming) {
      const error = this.querySelector('[data-files-error]');
      const problems = [];

      incoming.forEach((file) => {
        if (this.files.length >= this.maxFiles) {
          problems.push(`${file.name} — that's more than ${this.maxFiles} files. Send the rest over email and we'll add them.`);
          return;
        }
        if (file.size > this.maxBytes) {
          problems.push(`${file.name} is ${this.formatSize(file.size)} — the limit is ${this.formatSize(this.maxBytes)} per file.`);
          return;
        }
        if (this.files.some((existing) => existing.name === file.name && existing.size === file.size)) return;
        this.files.push(file);
      });

      if (problems.length) {
        error.textContent = problems.join(' ');
        error.hidden = false;
      } else {
        error.hidden = true;
      }
      this.renderFiles();
    }

    renderFiles() {
      const list = this.querySelector('[data-file-list]');
      list.innerHTML = '';
      this.files.forEach((file, index) => {
        const item = document.createElement('li');
        item.className = 'design-brief__file';
        item.innerHTML =
          `<span class="design-brief__file-name">${file.name}</span>` +
          `<span class="design-brief__file-size">${this.formatSize(file.size)}</span>`;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'design-brief__file-action';
        remove.textContent = 'Remove';
        remove.setAttribute('aria-label', `Remove ${file.name}`);
        remove.addEventListener('click', () => {
          this.files.splice(index, 1);
          this.renderFiles();
        });
        item.append(remove);
        list.append(item);
      });
    }

    formatSize(bytes) {
      if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))}KB`;
      return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
    }

    /* ---------------- persistence ---------------- */

    save() {
      try {
        const data = this.collect(false);
        data.rows = this.readRows();
        sessionStorage.setItem(this.storageKey, JSON.stringify(data));
        this.querySelector('[data-saved-note]').hidden = false;
      } catch (error) {
        /* private mode, quota, or storage disabled — the form still works */
      }
    }

    restore() {
      let saved;
      try {
        saved = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
      } catch (error) {
        saved = null;
      }
      if (!saved) return;

      Object.keys(saved).forEach((key) => {
        const field = this.form.elements[key];
        if (!field || key === 'rows' || key === 'liked_designs') return;
        if (field instanceof RadioNodeList || field.type === 'radio') {
          this.form.elements[key].value = saved[key];
        } else if (field.type !== 'file') {
          field.value = saved[key];
        }
      });

      (saved.liked_designs || []).forEach((handle) => {
        const box = this.querySelector(`[name="liked_designs"][value="${CSS.escape(handle)}"]`);
        if (box) box.checked = true;
      });

      if (Array.isArray(saved.rows) && saved.rows.length) {
        this.rowsWrap.innerHTML = '';
        saved.rows.forEach((state) => this.buildRow(state));
      }

      this.querySelector('[data-saved-note]').hidden = false;
    }

    clearSaved() {
      try {
        sessionStorage.removeItem(this.storageKey);
      } catch (error) {
        /* nothing to clean up */
      }
    }

    /* ---------------- turnstile ---------------- */

    // Loads the script only. Rendering waits until the widget's container is
    // actually on screen — see renderTurnstile.
    mountTurnstile() {
      if (!this.turnstileKey) return;

      if (window.turnstile) {
        this.turnstileReady = true;
        this.renderTurnstile();
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.onload = () => {
        this.turnstileReady = true;
        this.renderTurnstile();
      };
      document.head.append(script);
    }

    // Turnstile measures its container as it renders, so a widget created inside a
    // display:none panel comes out zero-width with no iframe and never yields a
    // token — which reads as a broken challenge and rejects every real submission.
    // The mount lives in step 5, so render the first time step 5 is on screen.
    renderTurnstile() {
      if (!this.turnstileKey || !this.turnstileReady) return;
      if (this.turnstileId !== undefined) return;
      const mount = this.querySelector('[data-turnstile-mount]');
      if (!mount || !mount.offsetParent) return;

      // `action` is echoed back by siteverify, so n8n can confirm the token was
      // minted by THIS form and not lifted from another page on the domain.
      this.turnstileId = window.turnstile.render(mount, {
        sitekey: this.turnstileKey,
        action: 'design-brief',
        theme: 'light',
      });
    }

    turnstileToken() {
      if (!this.turnstileKey || !window.turnstile || this.turnstileId === undefined) return '';
      return window.turnstile.getResponse(this.turnstileId) || '';
    }

    /* ---------------- submit ---------------- */

    collect(derive) {
      const data = {};
      ['contact_name', 'contact_email', 'contact_phone', 'job_title', 'partner_brand', 'partner_web',
       'co_branding', 'launch_model', 'project_type', 'blank_source', 'design_count', 'has_sizes',
       'brief', 'needed_by', 'deadline_type', 'deadline_detail', 'ship_to'].forEach((name) => {
        const field = this.form.elements[name];
        if (field) data[name] = field.value;
      });

      data.liked_designs = Array.from(this.querySelectorAll('[name="liked_designs"]:checked')).map((box) => box.value);
      data.size_breakdown = Array.from(this.querySelectorAll('[data-size]'))
        .filter((input) => parseInt(input.value, 10) > 0)
        .map((input) => `${input.dataset.size} ×${parseInt(input.value, 10)}`)
        .join(', ');

      if (!derive) return data;

      const rows = this.readRows().filter((row) => row.product && row.units > 0);
      data.units = rows.reduce((sum, row) => sum + row.units, 0);
      data.garment_value = this.garmentValue(rows);
      data.product_lines = this.productLines(rows);
      data.rows = rows;
      data.liked_design_urls = data.liked_designs.map((handle) => `${window.location.origin}/products/${handle}`);
      data.file_count = this.files.length;
      data.company_url = this.form.elements.company_url.value;
      data.elapsed_seconds = Math.round((Date.now() - this.startedAt) / 1000);
      data.turnstile_token = this.turnstileToken();
      data.submitted_from = window.location.href;
      return data;
    }

    async submit() {
      if (this.submitting) return;
      if (!this.validateStep(5)) return;

      const errorEl = this.querySelector('[data-submit-error]');
      const button = this.querySelector('[data-submit]');

      if (!this.intakeUrl || !this.fileUrl) {
        errorEl.textContent = 'This form isn’t connected yet. Email support@boldaviator.com and we’ll take your brief that way.';
        errorEl.hidden = false;
        return;
      }

      // n8n answers blocked traffic with a plain 200 so a bot learns nothing. That's
      // right for bots and wrong for a person who simply hasn't ticked the box — they'd
      // be shown a success screen for a brief that was never saved. Catch it here.
      if (this.turnstileKey && !this.turnstileToken()) {
        errorEl.textContent = 'Complete the "I’m human" check just above, then send.';
        errorEl.hidden = false;
        const mount = this.querySelector('[data-turnstile-mount]');
        if (mount) mount.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      this.submitting = true;
      errorEl.hidden = true;
      button.disabled = true;
      button.textContent = 'Sending…';

      const payload = this.collect(true);

      try {
        const response = await fetch(this.intakeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!response.ok) throw new Error(`Intake responded ${response.status}`);
        const result = await response.json().catch(() => ({}));
        this.taskId = result.taskId || result.task_id || result.id || '';

        // A 200 with no task ID is a failure wearing a success costume. n8n answers
        // 200 with an empty body when a run ends without reaching its Respond node —
        // a ClickUp rejection does exactly that. Treating it as success showed the
        // partner a success screen for a brief that was never saved, and then posted
        // their files against a task ID that didn't exist.
        if (!this.taskId) throw new Error('Intake returned no task ID');

        this.clearSaved();
        this.form.hidden = true;
        this.querySelector('[data-intro]').hidden = true;
        this.querySelector('[data-progress]').hidden = true;

        await this.uploadFiles();

        // Only hides the panel when every file actually landed. Hiding it
        // unconditionally threw away the failed rows and their Retry buttons, so a
        // partner saw a clean success screen while a file had silently not sent.
        this.refreshUploadState();
        this.renderReceipt(payload);
        const success = this.querySelector('[data-success]');
        success.hidden = false;
        success.focus();
      } catch (error) {
        errorEl.textContent = 'That didn’t send. Nothing was lost — your answers are all still here. Try again, and if it keeps failing email support@boldaviator.com.';
        errorEl.hidden = false;
        button.disabled = false;
        button.textContent = 'Send the brief';
        this.submitting = false;
        // Turnstile tokens are single-use. Without this, the retry posts a spent
        // token and is rejected — the partner would sit there re-clicking Send.
        if (window.turnstile && this.turnstileId !== undefined) window.turnstile.reset(this.turnstileId);
      }
    }

    async uploadFiles() {
      if (!this.files.length) return;
      const panel = this.querySelector('[data-uploading]');
      const list = this.querySelector('[data-upload-list]');
      panel.hidden = false;
      list.innerHTML = '';

      const items = this.files.map((file) => {
        const item = document.createElement('li');
        item.className = 'design-brief__file';
        item.innerHTML =
          `<span class="design-brief__file-name">${file.name}</span>` +
          `<span class="design-brief__file-size">${this.formatSize(file.size)}</span>` +
          '<span class="design-brief__file-state">Waiting</span>';
        list.append(item);
        return item;
      });

      for (let index = 0; index < this.files.length; index += 1) {
        await this.uploadOne(this.files[index], items[index]);
      }
    }

    // The brief is already saved by this point, so a failed file is a nuisance
    // rather than a loss — but it has to stay on screen to be one the partner can act on.
    refreshUploadState() {
      const panel = this.querySelector('[data-uploading]');
      const failed = panel.querySelectorAll('.design-brief__file.is-error').length;

      if (failed === 0) {
        panel.hidden = true;
        return;
      }

      panel.hidden = false;
      panel.querySelector('.design-brief__uploading-title').textContent =
        failed === 1 ? 'One file didn’t send' : `${failed} files didn’t send`;
      panel.querySelector('.design-brief__uploading-text').textContent =
        'Your brief is saved and everything else arrived. Retry below, or email what’s missing to support@boldaviator.com and we’ll add it.';
    }

    async uploadOne(file, item) {
      const state = item.querySelector('.design-brief__file-state');
      const existingRetry = item.querySelector('.design-brief__file-action');
      if (existingRetry) existingRetry.remove();

      item.classList.remove('is-error', 'is-done');
      state.textContent = 'Sending…';

      const body = new FormData();
      body.append('file', file, file.name);
      body.append('taskId', this.taskId);

      try {
        const response = await fetch(this.fileUrl, { method: 'POST', body });
        if (!response.ok) throw new Error(`File webhook responded ${response.status}`);
        item.classList.add('is-done');
        state.textContent = 'Sent';
      } catch (error) {
        item.classList.add('is-error');
        state.textContent = 'Didn’t send';
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'design-brief__file-action';
        retry.textContent = 'Retry';
        retry.setAttribute('aria-label', `Retry sending ${file.name}`);
        retry.addEventListener('click', async () => {
          await this.uploadOne(file, item);
          this.refreshUploadState();
        });
        item.append(retry);
      }
    }

    renderReceipt(payload) {
      const list = this.querySelector('[data-receipt-list]');
      const rows = [
        ['Brand', payload.partner_brand],
        ['Contact', [payload.contact_name, payload.contact_email, payload.contact_phone].filter(Boolean).join(' · ')],
        ['Co-branded', payload.co_branding],
        ['Who sells it', payload.launch_model],
        ['What it’s for', payload.project_type],
        ['Blank', payload.blank_source],
        ['Product', payload.product_lines],
        ['Garment', payload.garment_value],
        ['Designs', payload.design_count],
        ['Sizes', payload.size_breakdown],
        ['Designs you liked', payload.liked_designs.join(', ')],
        ['Brief', payload.brief],
        ['Files', this.files.map((file) => file.name).join(', ')],
        ['Needed by', payload.needed_by],
        ['Deadline', [payload.deadline_type, payload.deadline_detail].filter(Boolean).join(' — ')],
        ['Shipping to', payload.ship_to],
      ];

      list.innerHTML = '';
      rows.filter(([, value]) => value).forEach(([label, value]) => {
        const dt = document.createElement('dt');
        dt.textContent = label;
        const dd = document.createElement('dd');
        dd.textContent = value;
        list.append(dt, dd);
      });
    }
  }

  if (!customElements.get('design-brief-form')) {
    customElements.define('design-brief-form', DesignBriefForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderSearch extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.input = this.querySelector('[data-search-input]');
      this.results = this.querySelector('[data-predictive-results]');
      this.predictiveUrl = this.dataset.predictiveUrl;
      this.activeIndex = -1;
      this.debounce = null;
      this.controller = null;
      if (!this.details) return;

      this.details.addEventListener('toggle', () => {
        if (this.details.open && this.input) {
          this.input.focus();
          this.input.setSelectionRange(this.input.value.length, this.input.value.length);
        } else {
          this.reset();
        }
      });

      if (this.input && this.results && this.predictiveUrl) {
        this.input.addEventListener('input', () => {
          clearTimeout(this.debounce);
          this.debounce = setTimeout(() => this.search(), 220);
        });
      }

      this.addEventListener('keydown', (event) => this.onKeydown(event));

      this.onDocumentClick = (event) => {
        if (this.details.open && !this.contains(event.target)) this.close();
      };
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    get options() {
      return this.results ? Array.from(this.results.querySelectorAll('[role="option"]')) : [];
    }

    async search() {
      const query = this.input.value.trim();
      if (query.length < 2) {
        this.reset();
        return;
      }
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.classList.add('header--searching');

      const params = new URLSearchParams({
        q: query,
        section_id: 'predictive-search',
        'resources[type]': 'product,query,article,page',
        'resources[limit]': '6',
      });

      try {
        const response = await fetch(`${this.predictiveUrl}?${params}`, { signal: this.controller.signal });
        if (!response.ok) throw new Error(response.statusText);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const section = doc.querySelector('#shopify-section-predictive-search');
        const markup = section ? section.innerHTML.trim() : '';
        this.classList.remove('header--searching');

        if (!markup) {
          this.reset();
          return;
        }
        this.results.innerHTML = markup;
        this.options.forEach((option, index) => { option.id = `header-predictive-option-${index}`; });
        this.activeIndex = -1;
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      } catch (error) {
        if (error.name !== 'AbortError') this.reset();
        this.classList.remove('header--searching');
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        if (!this.results || this.results.hidden) {
          this.close();
        } else {
          this.reset();
          this.input.focus();
        }
        return;
      }
      if (!this.results || this.results.hidden) return;
      const options = this.options;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.setActive((this.activeIndex + 1) % options.length);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.setActive((this.activeIndex - 1 + options.length) % options.length);
      } else if (event.key === 'Enter' && this.activeIndex >= 0) {
        event.preventDefault();
        options[this.activeIndex].click();
      }
    }

    setActive(index) {
      const options = this.options;
      options.forEach((option) => option.classList.remove('is-active'));
      this.activeIndex = index;
      const active = options[index];
      if (active) {
        active.classList.add('is-active');
        active.scrollIntoView({ block: 'nearest' });
        this.input.setAttribute('aria-activedescendant', active.id);
      } else {
        this.input.removeAttribute('aria-activedescendant');
      }
    }

    reset() {
      if (this.controller) this.controller.abort();
      this.classList.remove('header--searching');
      this.activeIndex = -1;
      if (this.results) {
        this.results.hidden = true;
        this.results.innerHTML = '';
      }
      if (this.input) {
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
      }
    }

    close() {
      this.reset();
      if (!this.details.open) return;
      this.details.open = false;
      const summary = this.details.querySelector('summary');
      if (summary) summary.focus();
    }
  }

  if (!customElements.get('header-search')) {
    customElements.define('header-search', HeaderSearch);
  }

  document.addEventListener('cart:updated', (event) => {
    const count = event.detail && typeof event.detail.count === 'number' ? event.detail.count : null;
    if (count === null) return;
    document.querySelectorAll('.header__cart-count').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  });

  /* Desktop mega/dropdown panels open on hover + focus-within (CSS only).
     Escape closes a keyboard-opened panel by moving focus out of the item. */
  document.querySelectorAll('.header__nav').forEach((nav) => {
    nav.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (!event.target.closest('.header__item--menu')) return;
      const focused = nav.querySelector(':focus');
      if (focused) focused.blur();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;

      const load = () => {
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const fresh = html.querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim().length) {
              this.innerHTML = fresh.innerHTML;
            }
          })
          .catch((e) => console.error('product-recommendations', e));
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, obs) => {
          if (!entries[0].isIntersecting) return;
          obs.disconnect();
          load();
        }, { rootMargin: '0px 0px 400px 0px' });
        observer.observe(this);
      } else {
        load();
      }
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[data-variant-id]');
      this.priceEl = this.querySelector('[data-price]');
      this.atcBtn = this.querySelector('[data-atc]');
      this.atcText = this.querySelector('[data-atc-text]');
      this.stage = this.querySelector('[data-stage]');
      this.thumbs = this.querySelector('[data-thumbs]');
      this.dots = this.querySelector('[data-dots]');
      this.live = this.querySelector('[data-gallery-live]');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const data = this.querySelector('[data-product-variants]');
      try {
        this.variants = JSON.parse(data.textContent);
      } catch (e) {
        this.variants = [];
      }

      this.strings = {
        add: this.dataset.strAdd || 'Add to cart',
        soldOut: this.dataset.strSoldOut || 'Sold out',
        unavailable: this.dataset.strUnavailable || 'Unavailable',
      };

      this.addEventListener('change', (e) => {
        if (e.target.matches('.product__swatch-input')) this.onVariantChange();
      });
      this.bindQuantity();
      this.initGallery();
      this.initLightbox();
      this.updateAvailability();
    }

    /* ---------- Gallery carousel ---------- */
    initGallery() {
      if (!this.stage) return;
      this.slides = Array.from(this.stage.querySelectorAll('[data-slide]'));
      if (!this.slides.length) return;

      this.slideById = {};
      this.slides.forEach((s) => {
        if (s.dataset.mediaId) this.slideById[s.dataset.mediaId] = parseInt(s.dataset.index, 10);
      });

      this.activeIndex = parseInt(this.dataset.initialIndex || '0', 10) || 0;
      const gallery = this.querySelector('[data-gallery]');
      if (gallery && gallery.dataset.initialIndex) {
        this.activeIndex = parseInt(gallery.dataset.initialIndex, 10) || 0;
      }

      // Thumbnail + dot navigation
      if (this.thumbs) {
        this.thumbs.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-thumb]');
          if (btn) this.goToIndex(parseInt(btn.dataset.thumb, 10), true);
        });
      }
      if (this.dots) {
        this.dots.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-dot]');
          if (btn) this.goToIndex(parseInt(btn.dataset.dot, 10), true);
        });
      }

      // Keyboard: arrows navigate, Enter/Space zooms
      if (this.slides.length > 1) {
        this.stage.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.goToIndex(this.activeIndex + 1, true);
          } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.goToIndex(this.activeIndex - 1, true);
          } else if (e.key === 'Home') {
            e.preventDefault();
            this.goToIndex(0, true);
          } else if (e.key === 'End') {
            e.preventDefault();
            this.goToIndex(this.slides.length - 1, true);
          } else if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.openLightbox(this.activeIndex);
          }
        });
      }

      // Click / tap an image opens the lightbox (coexists with swipe)
      this.stage.addEventListener('click', (e) => {
        const slide = e.target.closest('[data-slide]');
        if (slide && slide.dataset.mediaType === 'image') this.openLightbox(parseInt(slide.dataset.index, 10));
      });
      const zoomOpen = this.stage.querySelector('[data-zoom-open]');
      if (zoomOpen) zoomOpen.addEventListener('click', () => this.openLightbox(this.activeIndex));

      // Track the active slide as the buyer swipes / scrolls.
      // A scroll listener (not IntersectionObserver) so it works in every context:
      // each slide is 100% of the stage, so the index is scrollLeft / stage width.
      if (this.slides.length > 1) {
        let raf = null;
        this.stage.addEventListener(
          'scroll',
          () => {
            if (raf) return;
            raf = requestAnimationFrame(() => {
              raf = null;
              const w = this.stage.clientWidth || 1;
              this.setActiveIndex(Math.round(this.stage.scrollLeft / w));
            });
          },
          { passive: true }
        );
      }

      // Jump to the initial slide (variant featured media) without animation
      if (this.activeIndex > 0) this.goToIndex(this.activeIndex, false);
      this.setActiveIndex(this.activeIndex);
    }

    goToIndex(index, smooth) {
      if (!this.slides || !this.slides.length) return;
      const i = Math.max(0, Math.min(index, this.slides.length - 1));
      const slide = this.slides[i];
      if (!slide) return;
      const behavior = smooth && !this.reduceMotion.matches ? 'smooth' : 'auto';
      this.stage.scrollTo({ left: slide.offsetLeft, behavior });
      this.setActiveIndex(i);
    }

    setActiveIndex(index) {
      const i = Math.max(0, Math.min(index, this.slides.length - 1));
      this.activeIndex = i;

      if (this.dots) {
        this.dots.querySelectorAll('[data-dot]').forEach((el) => {
          const on = parseInt(el.dataset.dot, 10) === i;
          el.classList.toggle('is-active', on);
          if (on) el.setAttribute('aria-current', 'true');
          else el.removeAttribute('aria-current');
        });
      }
      if (this.thumbs) {
        this.thumbs.querySelectorAll('[data-thumb]').forEach((el) => {
          const on = parseInt(el.dataset.thumb, 10) === i;
          el.classList.toggle('is-active', on);
          if (on) {
            el.setAttribute('aria-current', 'true');
            this.scrollThumbIntoView(el);
          } else {
            el.removeAttribute('aria-current');
          }
        });
      }
      if (this.live && this.slides[i]) {
        this.live.textContent = this.slides[i].getAttribute('aria-label') || '';
      }
    }

    scrollThumbIntoView(thumb) {
      if (!this.thumbs) return;
      const railW = this.thumbs.clientWidth;
      const left = thumb.offsetLeft;
      const right = left + thumb.offsetWidth;
      const view = this.thumbs.scrollLeft;
      const behavior = this.reduceMotion.matches ? 'auto' : 'smooth';
      if (left < view) {
        this.thumbs.scrollTo({ left: left, behavior });
      } else if (right > view + railW) {
        this.thumbs.scrollTo({ left: right - railW, behavior });
      }
    }

    /* ---------- Lightbox ---------- */
    initLightbox() {
      this.lightbox = this.querySelector('[data-lightbox]');
      if (!this.lightbox) return;
      this.lbImg = this.lightbox.querySelector('[data-lightbox-img]');
      this.lbCount = this.lightbox.querySelector('[data-lightbox-count]');
      this.lbClose = this.lightbox.querySelector('button[data-lightbox-close]');

      // Ordered list of zoomable (image) media
      this.zoomItems = (this.slides || [])
        .filter((s) => s.dataset.mediaType === 'image' && s.dataset.zoomSrc)
        .map((s) => ({ src: s.dataset.zoomSrc, alt: s.dataset.zoomAlt || '', slideIndex: parseInt(s.dataset.index, 10) }));

      this.lightbox.querySelectorAll('[data-lightbox-close]').forEach((el) =>
        el.addEventListener('click', () => this.closeLightbox())
      );
      const prev = this.lightbox.querySelector('[data-lightbox-prev]');
      const next = this.lightbox.querySelector('[data-lightbox-next]');
      if (prev) prev.addEventListener('click', () => this.lightboxStep(-1));
      if (next) next.addEventListener('click', () => this.lightboxStep(1));

      if (this.lbImg) {
        this.lbImg.addEventListener('click', () => this.lbImg.classList.toggle('is-zoomed'));
      }

      this.lightbox.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          this.closeLightbox();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.lightboxStep(1);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.lightboxStep(-1);
        } else if (e.key === 'Tab') {
          this.trapFocus(e);
        }
      });
    }

    openLightbox(slideIndex) {
      if (!this.lightbox || !this.zoomItems || !this.zoomItems.length) return;
      let pos = this.zoomItems.findIndex((it) => it.slideIndex === slideIndex);
      if (pos < 0) pos = 0;
      this.lastFocus = document.activeElement;
      this.lightbox.hidden = false;
      document.documentElement.classList.add('product-lightbox-open');
      this.lightboxRender(pos);
      if (this.lbClose) this.lbClose.focus();
    }

    lightboxRender(pos) {
      this.zoomPos = pos;
      const item = this.zoomItems[pos];
      if (!item || !this.lbImg) return;
      this.lbImg.classList.remove('is-zoomed');
      this.lbImg.src = item.src;
      this.lbImg.alt = item.alt;
      if (this.lbCount) this.lbCount.textContent = pos + 1 + ' / ' + this.zoomItems.length;
    }

    lightboxStep(delta) {
      if (!this.zoomItems.length) return;
      const n = this.zoomItems.length;
      const pos = (this.zoomPos + delta + n) % n;
      this.lightboxRender(pos);
    }

    closeLightbox() {
      if (!this.lightbox) return;
      this.lightbox.hidden = true;
      document.documentElement.classList.remove('product-lightbox-open');
      // Leave the main carousel on the image the buyer was viewing
      const item = this.zoomItems[this.zoomPos];
      if (item) this.goToIndex(item.slideIndex, false);
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') this.lastFocus.focus();
    }

    trapFocus(e) {
      const focusables = this.lightbox.querySelectorAll('button:not([hidden])');
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    get selectedValues() {
      const inputs = this.querySelectorAll('.product__swatch-input:checked');
      const values = [];
      inputs.forEach((input) => {
        const pos = parseInt(input.dataset.optionPosition, 10);
        values[pos - 1] = input.value;
      });
      return values;
    }

    matchVariant(values) {
      const target = values || this.selectedValues;
      return this.variants.find((v) => v.options.every((opt, i) => opt === target[i]));
    }

    onVariantChange() {
      const variant = this.matchVariant();

      this.querySelectorAll('[data-selected-value]').forEach((el) => {
        const pos = parseInt(el.dataset.selectedValue, 10);
        const val = this.selectedValues[pos - 1];
        if (val) el.textContent = val;
      });

      if (this.idInput && variant) this.idInput.value = variant.id;

      if (this.priceEl && variant) this.priceEl.textContent = variant.price;

      this.updateBuyButton(variant);
      this.updateMedia(variant);
      this.updateAvailability();
      this.updateUrl(variant);
    }

    updateBuyButton(variant) {
      if (!this.atcBtn || !this.atcText) return;
      if (!variant) {
        this.atcBtn.disabled = true;
        this.atcText.textContent = this.strings.unavailable;
      } else if (variant.available) {
        this.atcBtn.disabled = false;
        this.atcText.innerHTML = this.strings.add + ' — <span data-atc-price>' + variant.price + '</span>';
      } else {
        this.atcBtn.disabled = true;
        this.atcText.textContent = this.strings.soldOut;
      }
    }

    updateMedia(variant) {
      if (!variant || !variant.featured_media_id || !this.slideById) return;
      const idx = this.slideById[String(variant.featured_media_id)];
      if (typeof idx === 'number') this.goToIndex(idx, true);
    }

    updateAvailability() {
      const selected = this.selectedValues;
      this.querySelectorAll('.product__swatch-input').forEach((input) => {
        const pos = parseInt(input.dataset.optionPosition, 10);
        const test = selected.slice();
        test[pos - 1] = input.value;
        const match = this.variants.find((v) =>
          v.options.every((opt, i) => (i === pos - 1 ? opt === input.value : test[i] == null || opt === test[i]))
        );
        const wrapper = input.closest('.product__swatch');
        if (wrapper) wrapper.classList.toggle('is-unavailable', !match || !match.available);
      });
    }

    updateUrl(variant) {
      if (!variant || !this.dataset.variantUrl) return;
      const url = new URL(this.dataset.variantUrl, window.location.origin);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.pathname + url.search);
    }

    bindQuantity() {
      const input = this.querySelector('[data-qty-input]');
      const down = this.querySelector('[data-qty-down]');
      const up = this.querySelector('[data-qty-up]');
      if (!input) return;
      const step = (delta) => {
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.value = next;
      };
      if (down) down.addEventListener('click', () => step(-1));
      if (up) up.addEventListener('click', () => step(1));
      input.addEventListener('change', () => {
        if ((parseInt(input.value, 10) || 0) < 1) input.value = 1;
      });
    }
  }

  if (!customElements.get('product-info')) {
    customElements.define('product-info', ProductInfo);
  }

  /* App slots: mark each app block `is-filled` once it has height, and the
     slot `is-empty` while none does, so empty app shells leave no gap. The
     slot is observed rather than each block — apps fill in asynchronously
     and may replace their own nodes (Kite does), which would detach a
     per-block observer — and its children are re-read on every update.
     A MutationObserver backs up the ResizeObserver: resize callbacks are
     tied to rendering and don't run in a hidden tab, mutations always do. */
  (function () {
    function watch(slot) {
      if (slot.hasAttribute('data-app-slot-watched')) return;
      slot.setAttribute('data-app-slot-watched', '');
      function update() {
        var anyFilled = false;
        Array.prototype.forEach.call(slot.children, function (block) {
          var filled = block.getBoundingClientRect().height > 0;
          block.classList.toggle('is-filled', filled);
          if (filled) anyFilled = true;
        });
        slot.classList.toggle('is-empty', !anyFilled);
      }
      update();
      if ('ResizeObserver' in window) {
        new ResizeObserver(update).observe(slot);
      }
      new MutationObserver(update).observe(slot, { childList: true, subtree: true });
    }

    function init(root) {
      (root || document).querySelectorAll('.product__app-slot').forEach(watch);
    }

    init();
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  class SearchResults extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.addEventListener('click', (event) => {
        const more = event.target.closest('[data-load-more]');
        if (more) {
          event.preventDefault();
          this.loadMore(more.getAttribute('href'));
        }
      });
    }

    async loadMore(url) {
      this.classList.add('search--loading');
      const fetchUrl = `${url}${url.includes('?') ? '&' : '?'}section_id=${this.sectionId}`;
      try {
        const response = await fetch(fetchUrl);
        if (!response.ok) throw new Error(response.statusText);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

        const newGrid = doc.querySelector('[data-grid]');
        const currentGrid = this.querySelector('[data-grid]');
        if (newGrid && currentGrid) currentGrid.append(...newGrid.children);

        const newFooter = doc.querySelector('[data-footer]');
        const currentFooter = this.querySelector('[data-footer]');
        if (currentFooter) {
          if (newFooter) {
            currentFooter.replaceWith(newFooter);
          } else {
            currentFooter.remove();
          }
        }
        this.classList.remove('search--loading');
      } catch (error) {
        window.location.href = url;
      }
    }
  }

  if (!customElements.get('search-results')) {
    customElements.define('search-results', SearchResults);
  }

  } catch(e) { console.error(e); }
})();
})();
